import React from 'react';
import { DarkerDivider } from "../commonStyles";
import { ContainerCard, FlowCardGrid } from './styles';
import PropTypes from "prop-types";

const borderBottomNoneQ = [];
function trackGrids(grid) {
  let cardRowWidth = 0;
  let firstRowGrids = true;
  cardRowWidth += +grid.gridWidth;
  const ceilWidth = Math.ceil(cardRowWidth);
  if (firstRowGrids) {
    if (ceilWidth === 100) {
      cardRowWidth = 0;
      firstRowGrids = false;
    }
    return true;
  }
  if (borderBottomNoneQ.length && ceilWidth < 100) {
    return true;
  }
  if (ceilWidth === 100 && borderBottomNoneQ.length) {
    while (borderBottomNoneQ.length) {
      borderBottomNoneQ.shift();
    }
    cardRowWidth = 0;
    return true;
  }
  if (ceilWidth === 100) cardRowWidth = 0;
  return false;
}

function gridStyle(width) {
  return {
    width: `${width}%`,
  };
}

function FlowCard(props) {
  const { cardConfig, styleConfig, index, stickyId } = props;
  if (!cardConfig) return <div>no data</div>;
  return (
    <ContainerCard
      bordered={styleConfig && styleConfig.cardBorder}
      cardParity={index}
      cardPadding={styleConfig && styleConfig.cardPadding}
      marginBottom={styleConfig && styleConfig.marginBottom}
      styleConfig={styleConfig}
    >
      {cardConfig.map((each, gridIndex) => {
        if (each.noBorderBottom) {
          borderBottomNoneQ.push(each.name);
        }
        return (
          <FlowCardGrid
            id={stickyId || ''}
            cardDetail={{
              type: each.type,
              gridWidth: each.gridWidth,
              ptop: each.ptop,
              pbottom: each.pbottom,
              pleft: each.pleft,
              pright: each.pright,
            }}
            style={gridStyle(each.gridWidth)}
            borderNone={trackGrids(each)}
            key={gridIndex}
            className={each.className || ''}
          >
            {each.render}
          </FlowCardGrid>
        );
      })}
      <DarkerDivider
        className={
          props.dataIndex !== props.length - 1
            && (props.styleConfig && props.styleConfig.cardDivider === false)
            ? 'mt1 mb1'
            : 'display-none'
        }
      />
    </ContainerCard>
  );
}

FlowCard.propTypes = {
  cardConfig: PropTypes.array,
  dataIndex: PropTypes.number,
  index: PropTypes.number,
  length: PropTypes.number,
  stickyId: PropTypes.string,
  styleConfig: PropTypes.object
}

export default FlowCard;
